
export const DEFAULT_APP_LANGS: Record<string, string> = {
  en: 'English',
  de: 'Deutsch',
  fr: 'Français',
  pt: 'Português',
  es: 'Español',
  ar: 'العربية',
  kr: '한국어',
  jp: '日本語',
  zh: '中文'
};

export const mapLanguageCodesToLabels = (codes: string[]): Record<string, string> => {
  return codes.reduce<Record<string, string>>((accumulator, code) => {
    if (!code) {
      return accumulator;
    }

    const normalizedCode = code.toLowerCase();

    return {
      ...accumulator,
      [normalizedCode]: DEFAULT_APP_LANGS[normalizedCode] || normalizedCode.toUpperCase()
    };
  }, {});
};
